import type { DocumentWorkflowSignature } from "../entities/document-workflow";
import { VerificationBadge } from "./FileBadges";
import { certificateName, displayDateTime } from "./fileLabels";

/**
 * Безопасные сведения о подписи и сертификате.
 *
 * Только то, что отдаёт контракт: владелец и издатель показываются общим
 * именем, без остальных реквизитов отличительного имени; тела подписи и
 * ключевого материала у интерфейса нет вовсе.
 */
export function SignatureDetails({
  signature,
}: {
  signature: DocumentWorkflowSignature;
}) {
  const { certificate } = signature;

  return (
    <dl className="signature-details">
      <div>
        <dt>Проверка на сервере</dt>
        <dd>
          <VerificationBadge state={signature.verification_state} />
        </dd>
      </div>
      <div>
        <dt>Владелец сертификата</dt>
        <dd>{certificateName(certificate.subject)}</dd>
      </div>
      <div>
        <dt>Издатель сертификата</dt>
        <dd>{certificateName(certificate.issuer)}</dd>
      </div>
      <div>
        <dt>Сертификат действителен</dt>
        <dd>
          {displayDateTime(certificate.valid_from)} —{" "}
          {displayDateTime(certificate.valid_to)}
        </dd>
      </div>
      <div>
        <dt>Отпечаток сертификата</dt>
        <dd>
          <code>{certificate.thumbprint ?? "не указан"}</code>
        </dd>
      </div>
      <div>
        <dt>Профиль</dt>
        <dd>{signature.cades_profile}</dd>
      </div>
      <div>
        <dt>Подписано</dt>
        <dd>{displayDateTime(signature.signed_at)}</dd>
      </div>
      <div>
        <dt>SHA-256 подписи</dt>
        <dd>
          <code>{signature.signature_sha256}</code>
        </dd>
      </div>
    </dl>
  );
}
